import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { loadDiyCategories, type DiyCategory } from '@/services/content'
import styles from './DIYAll.module.css'

export default function DIYAll() {
  const navigate = useNavigate()
  const [categories, setCategories] = useState<DiyCategory[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadDiyCategories()
      .then(setCategories)
      .finally(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Loading...</div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <button className={styles.backButton} onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h1 className={styles.title}>DIY Activities</h1>
        <p className={styles.subtitle}>Fun activities you can do at home with simple materials</p>
      </header>

      <div className={styles.grid}>
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={styles.categoryCard}
            style={{ backgroundColor: cat.color }}
            onClick={() => navigate(`/diy/${cat.id}`)}
          >
            <span className={styles.categoryEmoji}>{cat.emoji}</span>
            <span className={styles.categoryTitle}>{cat.title}</span>
            <span className={styles.categoryDesc}>{cat.description}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
